import { get, handleApiError, post } from '@helpers/httpClient';

import {
  mapWorkoutFullInviteToFront,
  mapWorkoutShortInviteToFront,
} from '../@mappers/workoutsInvites.mapper';
import {
  IWorkoutFullInviteDTO,
  IWorkoutShortInviteDTO,
} from '../@types/DTO/workoutsInvites.dto.types';
import { IWorkoutFullInvite, IWorkoutShortInvite } from '../@types/workoutsInvites.types';

export const getWorkoutInvitesForCurrentUser = async (): Promise<IWorkoutFullInvite[]> => {
  const res = await get('/ajax/workouts/invites/user_invites.php').then<IWorkoutFullInviteDTO[]>(
    handleApiError,
  );
  return res.map(mapWorkoutFullInviteToFront);
};

export const getWorkoutInvitesForWorkout = async (
  id_workout: number,
): Promise<IWorkoutShortInvite[]> => {
  const res = await get('/ajax/workouts/invites/workout_invites.php', { id_workout }).then<
    IWorkoutShortInviteDTO[]
  >(handleApiError);
  return res.map(mapWorkoutShortInviteToFront);
};

export const getWorkoutInvitesCountForCurrentUser = async (): Promise<number> => {
  const res = await get<{ count: string }>('/ajax/workouts/invites/user_invites_count.php');
  return +res.count;
};

export const addInviteUserToWorkout = async (
  id_user: number,
  id_workout: number,
): Promise<number> => {
  const res = await post('/ajax/workouts/invites/add_invite_user_to_workout.php', {
    id_user,
    id_workout,
  }).then<{ count: string }>(handleApiError);
  return +res.count;
};

export const deleteInviteUserFromWorkout = async (id: number): Promise<boolean> => {
  const res = await post('/ajax/workouts/invites/delete_invite_user_to_workout.php', { id }).then<{
    success: boolean;
  }>(handleApiError);
  return !!res.success;
};

export const acceptWorkoutInvite = async (
  id: number,
): Promise<{ workout_id: number; workout_group: number }> => {
  const res = await post('/ajax/workouts/invites/accept_invite.php', { id }).then<{
    success: boolean;
    workout_id: number;
    workout_group: number;
  }>(handleApiError);
  return res;
};

export const rejectWorkoutInvite = async (id: number): Promise<boolean> => {
  const res = await post('/ajax/workouts/invites/reject_invite.php', { id }).then<{
    success: boolean;
  }>(handleApiError);
  return !!res.success;
};
